import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../utils/AxiosInstance";
import { AppContext } from "../context/AppContext";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { FaCircleExclamation } from "react-icons/fa6";
import { FaInfoCircle } from "react-icons/fa";
import { useMediaQuery } from '@mui/material';
import { useMsal } from "@azure/msal-react";
import { getActivityActor } from "../utils/activityActor";


const AddReportsDataModal = ({ isOpen, onClose, rollUpDropdown, fetchReports, userOptions, searchTerm }) => {
    const { setLoader, setToast, reportOptions ,viewerUsers, setViewerUsers} = useContext(AppContext);
    const [selectedRoles, setSelectedRoles] = useState();
    const [rolesOptions, setRolesOption] = useState();
    const [selectedEmail, setSelectedEmail] = useState([]);
    const [showTooltip, setShowTooltip] = useState(false);
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const { instance } = useMsal();
    const account = instance.getActiveAccount();
    const actor = getActivityActor(account);
const { setApplicationOption,ApplicationOption,selectapplication,setSelectapplication,reportId}=useContext(AppContext)
    const {
        register,
        handleSubmit,
        formState: { errors, disabled },
        reset,
        watch
    } = useForm();

    // const fetchData = async () => {


    //     try {
    //         const response = await axiosInstance.get(`/bookmarks`);
    //         if (response.status === 200) {
    //             // setBookMarks(response.data);
    //             setRolesOption(response.data
    //                 .filter((item) => item.url && item.url.trim() !== "") // Filter items with non-empty 'url'
    //                 .map((item) => ({
    //                     value: item._id,
    //                     label: item.title
    //                 }))
    //             );
    //             // setRolesOption(response.data.map((item) => {
    //             //     return {
    //             //         value: item._id,
    //             //         label: item.title,
    //             //     }
    //             // }))
    //         }
    //     } catch (error) {
    //         console.error("Error fetching data:", error);
    //     }
    // };


    const filteredUserOptions = userOptions.filter(user => user.role.toLowerCase() === "viewer");
//      const fetchApplications = async () => {
//        try {
//          setLoader(true);
//          const response = await axiosInstance.get("/getexternalReports");
//          console.log(response, "responseresponse++");
//          if (response.data) {
//            setApplicationOption(
//              response.data?.data?.map((item) => ({
//                value: item.ID,
//                label: item.NAME,
//              }))
//            );
//          }
//          setLoader(false);
//        } catch (error) {
//          setLoader(false);
//          console.error("Error fetching roles:", error);
//        }
//      };
// useEffect(()=>{
//     fetchApplications()
// },[])
    const fetchUserReports = async (email) => {
        setSelectedRoles([])
        setSelectapplication([])
        setRolesOption([])
        setLoader(true)
        try {
            //   const emailParam = `[${email.map(e => e.email).join(",")}]`;
            //         let emailParam = "";
            // if (email.length === 1) {
            //   emailParam = email[0].email;
            // } else {
            //   emailParam = `[${email.map(e => e.email).join(",")}]`;
            // }
            const emailParam = email.map(e => e.email).join(",");
            const response = await axiosInstance.get(`/getAssignedReports?email=${encodeURIComponent(emailParam)}`);
            if (response.status == 200) {
                setLoader(false);
                // setSelectedRoles(response?.data?.reports.map((item) => {
                //     return {
                //         label: item.title,
                //         value: item._id
                //     }
                // }) || []);
                 const reports = response?.data?.reports || [];

      
      const applicationReports = reports.filter((item) =>
     item.type == "Web Application"
      );

      const normalReports = reports.filter(
        (item) => item.type !== "Web Application"
      );

      // Map into react-select format
      const appSelectValues = applicationReports.map((item) => ({
        label: item.title,
        value: item._id,
      }));

      const reportSelectValues = normalReports.map((item) => ({
        label: item.title,
        value: item._id,
      }));

      // Set separately
      setSelectapplication(appSelectValues);
      setSelectedRoles(reportSelectValues);

      console.log("Existing reports split:", {
        reportSelectValues,
        appSelectValues,
      });

                
            }

        } catch (error) {
            console.error("Error fetching roles:", error);
        }
    };


    const onSubmit = async (data) => {
        setLoader(true);
         const roleIds = selectedRoles.map((item) => item.value);
          const reportIds = selectapplication.map((r) => r.value);
           const combinedIds = [...roleIds, ...reportIds];
              const payload = {
      emails: selectedEmail.map((e) => e.email),
      _id: combinedIds,
      ...actor,
    };
        // const payload = { emails: selectedEmail.map(e => e.email), _id: selectedRoles.map((item) => item.value) , reportId: selectapplication.map(r => ({ _id: r.value })) }
        try {
            const response = await axiosInstance.post("/addReport", payload);
            if (response.status === 200) {
                setLoader(false);
                setToast({ show: true, type: "success", message: response?.data?.message || "Report added Successfully" });
                fetchReports({ page: 1, searchTerm: searchTerm })
                onClose();
                reset();  // Clear form after successful submission
            }
        } catch (error) {
            setLoader(false);
            // setToast({
            //     show: true, type: "error", message: error.response?.data?.message ||
            //         `GL Client Rollup ${data.GROUP3_GL_CLIENT_ROLLUP} Already Exists`
            // });
        } finally {
            setLoader(false);
        }
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            maxHeight: "110px", // Limit height to allow scrolling after 4 items
            //   overflowY: "auto", // Enable scrolling
            flexWrap: "wrap",
            //   paddingBottom:"5px"
        }),
        // valueContainer: (provided) => ({
        //   ...provided,
        //   display: "flex",
        //   flexWrap: "wrap",
        //   maxHeight: "90px", // Limit height for multi-line appearance
        //   overflowY: "auto",
        // }),
        multiValue: (provided) => ({
            ...provided,
            flex: "0 0 48%", // Makes each tag take half the width (for 2 per row)
            margin: "2px", // Adjust spacing
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
    };


   

    useEffect(() => {

        if (selectedEmail.length != 0) {
            fetchUserReports(selectedEmail)
        }else{
            setSelectedRoles(null)
setSelectapplication(null)
        }
    }, [selectedEmail])

// Get selected report labels
const selectedReportLabels = selectedRoles?.map((r) => r.label) || [];

// Filter applications based on label matching
// const filteredApplications = ApplicationOption?.filter(app =>
//   selectedReportLabels.includes(app.label)
// ) || [];
const filteredApplications = viewerUsers.users.map((user)=>user)
console.log(filteredApplications,'setViewerUsers')
    return (
        <div className=" fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 max-h-[100vh] overflow-auto">
            <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md relative m-10">
                <button onClick={onClose} className="absolute sm:top-3 top-5 right-3 text-gray-500 hover:text-gray-800 text-xl font-bold">
                    &times;
                </button>

                <h2 className="sm:text-2xl text-[14px] font-semibold mb-6 text-center">Assign Reports/Dashboards</h2>
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                    {/* Distribution Client */}
                    {/* Group */}
                    <div>
                        <div className="flex items-center gap-1 relative">
                            <label className="sm:text-sm text-[12px] font-medium">Email</label>
                            <div
                                className="relative flex items-center cursor-pointer"
                                onMouseEnter={() => setShowTooltip(true)}
                                onMouseLeave={() => setShowTooltip(false)}
                            >
                                <FaInfoCircle className="text-gray-500 hover:text-gray-700" />
                                {showTooltip && (
                                    <div className="absolute  bottom-5 bg-gray-700 text-white text-xs rounded-md px-2 py-1 whitespace-nowrap">
                                        Only viewers are listed
                                    </div>
                                )}
                            </div>
                        </div>
                        <Select
                            isMulti
                            options={filteredApplications}
                            value={selectedEmail}
                            onChange={setSelectedEmail}
                            getOptionValue={(e) => e.email}
                            getOptionLabel={(e) => `${e.email} (${e.role})`}
                            className="outline-none focus:outline-none"
                            classNamePrefix="react-select"
                            placeholder="Select Email"
                            required
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    maxHeight: "200px", // Set max height for dropdown
                                    overflowY: "auto", // Enable vertical scrolling only in the dropdown
                                    scrollbarWidth: "thin", // Hide extra scrollbar in Firefox
                                }),
                                menuList: (provided) => ({
                                    ...provided,
                                    maxHeight: isSmallScreen ? "100px" : "150px",
                                    overflowY: "auto",
                                    fontSize: isSmallScreen ? "12px" : "14px"
                                }),
                                control: (provided) => ({
                                    ...provided,
                                    minHeight: "40px", // Maintain select box size
                                }),
                            }}
                        />
                    </div>
                    <div>
                        <label className="block sm:text-sm text-[12px] font-medium">Reports</label>
                        <Select
                            isMulti
                            id="role"
                            value={selectedRoles}
                            onChange={(selected) => {
                                setSelectedRoles(selected);
                            }}
                            options={reportOptions}
                            // styles={customStyles}
                            className="mt-1"
                            // required
                            placeholder="Select Report"
                            styles={customStyles}
                        />
                    </div>
                    <div>
                           <label className="block sm:text-sm text-[12px] font-medium">Application</label>
                           <Select
                            id="application"
                            value={selectapplication}
                            onChange={(selected) =>
                              setSelectapplication(selected)
                            }
                            // options={ApplicationOption}
                            options={reportId}
                            className="mt-1"
                            isClearable={true}
                            isMulti
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            menuShouldScrollIntoView={false}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              menuList: (provided) => ({
                                ...provided,
                                maxHeight: isSmallScreen ? "80px" : "150px",
                                overflowY: "auto",
                                fontSize: isSmallScreen ? "10px" : "14px",
                              }),
                            }}
                            // required
                          />
                    </div>
                    <button
                        type="submit"
                          disabled={
                                    (selectedRoles?.length === 0 && selectapplication?.length === 0) ||
                                    Object.keys(errors)?.length > 0
                                }
                        // disabled={selectedRoles?.length == 0 || Object.keys(errors).length > 0}
                        className={`w-full px-6 py-2 text-white rounded-md focus:outline-none bg-[#E31c23] ${(selectedRoles?.length === 0 && selectapplication?.length === 0 || Object.keys(errors)?.length > 0)
                            ? "cursor-not-allowed"
                            : " hover:bg-[#b91c1c] transition-colors duration-300"
                            }`}
                    >
                        Submit
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AddReportsDataModal;
